import React, { useEffect } from "react";
import { connect } from "react-redux";
// core components
import IndexHeaderVideo from "components/Headers/IndexHeaderVideo.js";
import IndexHeader from "components/Headers/IndexHeader.js";
// my components
import Loading from "../../Loading/Loading";
import CardBlockProductType from "../../../components/CardBlockProductType/CardBlockProductType";
import CardBlockSlider from "../../../components/CardBlockSlider/CardBlockSlider";
import CardIntroAbout from "../../../components/CardIntroAbout/CardIntroAbout";
import CardContentIntro from "../../../components/CardContentIntro/CardContentIntro";
import GoogleMap from "../../../components/Map/Map";
import {
  getProductsBestSeller,
  getProductsInterest,
} from "../../../redux/actions/products_actions";
import { HOST_URL } from "../../../utils/misc";

const Home = (props) => {  
  useEffect(() => {
    props.dispatch(getProductsBestSeller())
    props.dispatch(getProductsInterest())

    document.body.classList.add("index")
    return function cleanup() {
      document.body.classList.remove("index")
    }
  }, []);

  const renderHeader = () => {
    let windowWidth = window.innerWidth;
    if(windowWidth <= 760) 
      return(
        <IndexHeader title={props.templates.templates.templateProperties.store_name} imageUrl={HOST_URL + props.templates.templates.templateProperties.image_homepage} />
      )
    return(
      <IndexHeaderVideo title={props.templates.templates.templateProperties.store_name} />
    )
  }

  if(props.products.productBestSeller && props.products.productInterest && props.templates.templates) {
    //props.templates.templates.templateProperties.title_card_content_intro
    return (
      <>
        <Loading />
        {renderHeader()}
        <CardBlockProductType />
        <CardBlockSlider 
          list={props.products.productBestSeller.products}
          type="best seller"
          title="Sản Phẩm Bán Chạy" />
        <CardIntroAbout />
        <CardContentIntro />
        <CardBlockSlider 
          list={props.products.productInterest.products}
          type="products interest"
          title="Sản Phẩm Dành Cho Bạn" />
        <GoogleMap />
      </>
    );
  }
  else {
    return(null)
  }
}

const mapStateToProps = (state) => {
  return {
    products: state.products,
    templates: state.templates,
  };
};

export default connect(mapStateToProps)(Home);